const config = {
  NAME: 'Subir Archivos',
  PATH: '/subir-archivos',
};

export default config;
